import { provideHttpClient } from '@angular/common/http';
import {
    ApplicationConfig,
    CSP_NONCE,
    importProvidersFrom,
} from '@angular/core';
import {
    PreloadAllModules,
    provideRouter,
    withInMemoryScrolling,
    withPreloading,
} from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { LuxonDateAdapter } from '@angular/material-luxon-adapter';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { provideNgxMask } from 'ngx-mask';
import { provideFuse } from '@fuse';
import { provideAuth } from 'app/core/auth/auth.provider';
import { provideTransloco } from 'app/core/transloco/transloco.provider';
import { provideGlobalError } from 'app/core/error/global-error.provider';
import { provideIcons } from 'app/core/icons/icons.provider';
import { mockApiServices } from 'app/core/shared/mock-api';
import { environment } from 'environments/environment';
import { appRoutes } from 'app/app.routes';
import { ServiceWorkerModule } from '@angular/service-worker';
import { provideGlobalSuccess } from './core/success/global-success.provider';
import { OfflineDetectionService } from './core/services/offline-detection.service';

export const appConfig: ApplicationConfig = {
    providers: [
        provideAnimations(),
        provideHttpClient(),
        provideRouter(
            appRoutes,
            withPreloading(PreloadAllModules),
            withInMemoryScrolling({ scrollPositionRestoration: 'enabled' })
        ),

        // Initialize OfflineDetectionService early
        OfflineDetectionService,

        // Material Date Adapter
        {
            provide: DateAdapter,
            useClass: LuxonDateAdapter,
        },
        {
            provide: MAT_DATE_FORMATS,
            useValue: {
                parse: {
                    dateInput: 'D',
                },
                display: {
                    dateInput: 'DDD',
                    monthYearLabel: 'LLL yyyy',
                    dateA11yLabel: 'DD',
                    monthYearA11yLabel: 'LLLL yyyy',
                },
            },
        },
        {
            provide: CSP_NONCE,
            useValue: globalThis.anyNonceValue,
        },

        // Transloco Config
        provideTransloco(),

        // Import Service Worker module
        importProvidersFrom(
            ServiceWorkerModule.register('ngsw-worker.js', {
                enabled: environment.production,
                // Register the ServiceWorker as soon as the application is stable
                // or after 30 seconds (whichever comes first).
                registrationStrategy: 'registerWhenStable:30000',
            })
        ),

        // Import provideNgxMask
        provideNgxMask(),

        // Global error handling
        provideGlobalError(),

        // Global success handling
        provideGlobalSuccess(),

        // Fuse
        provideAuth(),
        provideIcons(),
        provideFuse({
            mockApi: {
                delay: 0,
                services: mockApiServices,
            },
            fuse: {
                layout: 'modern',
                scheme: 'light',
                screens: {
                    sm: '600px',
                    md: '960px',
                    lg: '1280px',
                    xl: '1440px',
                },
                theme: 'theme-wellSite',
                // theme: 'theme-aem',
                themes: [
                    {
                        id: 'theme-default',
                        name: 'Default',
                    },
                    {
                        id: 'theme-brand',
                        name: 'Brand',
                    },
                    {
                        id: 'theme-teal',
                        name: 'Teal',
                    },
                    {
                        id: 'theme-rose',
                        name: 'Rose',
                    },
                    {
                        id: 'theme-purple',
                        name: 'Purple',
                    },
                    {
                        id: 'theme-amber',
                        name: 'Amber',
                    },
                    {
                        id: 'theme-aem',
                        name: 'AEM',
                    },
                ],
            },
        }),
    ],
};
